import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import { sendError } from "lib/sentryHelper";

const SET_NEED_SHUT_APP_DOWN = "appError/SET_NEED_SHUT_APP_DOWN";
const INIT_ALL_DATA = "appError/INIT_ALL_DATA";

const setNeedShutAppDown = createAction(SET_NEED_SHUT_APP_DOWN);
const initAllData = createAction(INIT_ALL_DATA);

/**
 * fatal, safe 에러 구분기준
 * fatal
 *   오류가 발생하고 계속진행이 여러 이유로 불가능할 경우(보안 혹은 다음액선으로의 진행에 영향주는 경우 등)
 *   특정 액션으로 오류가 발생한 상태에서 같은액션이 반복되면 백엔드에 혼란이 생기는 경우(이미지 업로드 실패후 또 업로드수행 가능할 경우.)
 *   스크롤 등의 이유로 오류가 계속 발생하는 경우.
 * safe
 *   (하단의 이유로 데일리룩 리스트 모두).
 *   오류가 발생했지만 오류인지 티가 안날경우.
 *   특정 액션으로 오류가 발생한 상태에서 같은액션이 반복되어도 백엔드에 혼란이 가지 않는 경우(로그인실패등.)
 */

/**
 * setSafeAppError 함수를 사용할 수 없는 환경 이외에는 sendError 함수를 직접 사용하지 말자.
 */

export const setFatalAppError = error => (dispatch, getState) => {
  dispatch(setNeedShutAppDown(true));
  sendError(error);
};

export const setSafeAppError = error => (dispatch, getState) => {
  sendError(error);
};

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  needShutAppDown: false
});

export default handleActions(
  {
    [SET_NEED_SHUT_APP_DOWN]: (state, action) => {
      const needShutAppDown = action.payload;
      return state.set("needShutAppDown", fromJS(needShutAppDown));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
